/* Package JSON Import will be here */
import React from "react";
import { Icon, Header, Segment, Table, Pagination, Button, Modal, Form, Confirm, Search, Dropdown, Input } from 'semantic-ui-react';
import { Select } from "@material-ui/core";
/* Package JSON Import will be here */

/* Project Import will be here */
import { Constants } from '../../../../src/config/appConstants';
import NoResultFound from "../../sharedComponent/noResultFound";
import "./securityPage.css";
import "../../../assets/styles/styles.css";
import * as utility from '../../../services/utility';
/* Project Import will be here */

const SecurityPageComponent = (props) => {
    const myiconstyle = { color: "#f18f40", margin: "5px", cursor: "pointer" };
    return (
        <div>
            <Segment className="header-section">
                <Header as="h3">
                    <Icon name="shield alternate"></Icon>
                    <span>Security</span>
                </Header>

                <div style={{ display: 'flex', color: '#2196F3', alignItems: 'center' }}>
                    <h4 style={{ margin: '0' }}>Status:</h4>
                    <Select value={props.securityPage.selectedStatus} onChange={props.handleChange}>
                        {props.renderOptions()}
                    </Select>
                    <i aria-hidden="true"
                        onClick={() => { props.onOpenModel({ data: {} }); }}
                        style={myiconstyle} className="plus circle icon">
                    </i>
                </div>
            </Segment>
            <Table className="ui celled table">
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell className="tableCell"></Table.HeaderCell>
                        <Table.HeaderCell className="text-left">
                            Username
                            <Search className="theader" onSearchChange={props.onUserNameSearch} value={props.securityPage.securityUserNameSearchText}
                                placeholder={Constants.SEARCH_PLACEHOLDER} />
                        </Table.HeaderCell>
                        <Table.HeaderCell className="text-left">Employee Full Name
                            <Search className="theader" onSearchChange={props.onEmployeeNameSearch} placeholder={Constants.SEARCH_PLACEHOLDER} value={props.securityPage.securityEmployeeSearchText} />
                        </Table.HeaderCell>
                        <Table.HeaderCell className="text-left">Employee No
                            <Search className="theader" onSearchChange={props.onEmployeeNumberSearch} placeholder={Constants.SEARCH_PLACEHOLDER} value={props.securityPage.securityEmployeeNumberSearchText} />
                        </Table.HeaderCell>
                        <Table.HeaderCell className="text-left">Group
                            <Search className="theader" onSearchChange={props.onSecurityGroupSearch} placeholder={Constants.SEARCH_PLACEHOLDER} value={props.securityPage.securityGroupNameSearchText} />
                        </Table.HeaderCell>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {props.securityPage.userDataList && props.securityPage.userDataList.length > 0 ? props.securityPage.userDataList.map(({ employeeName, userName, userId, employeeNumber, securityGroupName, isActive }) => (
                        <Table.Row className="securityPage">
                            <Table.Cell textAlign="center" className="tableCell" >
                                <div className="securityIcon">
                                    <Icon style={{ fontSize: '0.9em' }} className="myiconstyle" edit name='edit pencil' onClick={() => { props.onOpenModel({ userId: userId }); }} />
                                    {(props.user.claimValue.includes(Constants.BUTTON_CLAIMS.USER_ACTIVATE_DEACTIVATE_BUTTON)) && (isActive ?
                                        <Icon style={{ fontSize: '0.9em' }} className="inActiveIcon" edit name='power off' onClick={() => { props.openDeactivateConfirmationPopup(userId); }} />
                                        :
                                        <Icon style={{ fontSize: '0.9em' }} className="activeIcon" edit name='power off' onClick={() => { props.openActivateConfirmationPopup(userId); }} />
                                    )}
                                </div>
                            </Table.Cell>
                            <Table.Cell>{userName}</Table.Cell>
                            <Table.Cell>{employeeName}</Table.Cell>
                            <Table.Cell>{employeeNumber}</Table.Cell>
                            <Table.Cell>{securityGroupName}</Table.Cell>
                        </Table.Row>
                    )) :
                        <Table.Row>
                            <Table.Cell colSpan='5'>
                                <NoResultFound displayMessage={Constants.NO_RESULT_FOUND} />
                            </Table.Cell>
                        </Table.Row>
                    }
                </Table.Body>
            </Table>
            <Confirm
                closeIcon
                open={props.securityPage.isDeActivateConfirmationModalVisible}
                content="Are you sure? Do you want to Deactivate this security user?"
                header='Confirmation'
                size="tiny"
                onCancel={() => { props.closeDeactivateConfirmationPopup() }}
                onConfirm={() => { props.onActivateOrDeactivateUser("deactivate") }}
            />
            <Confirm
                closeIcon
                open={props.securityPage.isActivateConfirmationModalVisible}
                content="Are you sure? Do you want to Reactivate this security user?"
                header='Confirmation'
                size="tiny"
                onCancel={() => { props.closeActivateConfirmationPopup() }}
                onConfirm={() => { props.onActivateOrDeactivateUser("activate") }}
            />
            <Modal closeIcon
                open={props.securityPage.isOpenModel}
                closeOnDimmerClick={false}
                onClose={() => { props.onCloseModel(); }}
            >
                <Modal.Header>Add User</Modal.Header>
                <Modal.Content scrolling>
                    <Form>
                        <Form.Group inline widths='equal'>
                            <Form.Field required>
                                <label>Employee ID:</label>
                                <Input
                                    placeholder='Enter Employee Id'
                                    value={props.securityPage.selectedValue ? props.securityPage.selectedValue.employeeNumber : ""}
                                    onChange={(e) => { props.handleEmployeeNumberChange(e, { name: 'employeeNumber', value: e.target.value }) }}
                                />
                            </Form.Field>
                        </Form.Group>
                        <Form.Group inline widths='equal'>
                            <Form.Field required>
                                <label>Employee Full Name:</label>
                                <Input
                                    placeholder='Enter Employee Full Name'
                                    value={props.securityPage.selectedValue ? props.securityPage.selectedValue.employeeName : ""}
                                    onChange={(e) => { props.handleEmployeeNameChange(e, { name: 'employeeName', value: e.target.value }) }}
                                />
                            </Form.Field>
                        </Form.Group>
                        <Form.Group inline widths='equal'>
                            <Form.Field required>
                                <label>User Name:</label>
                                <Input
                                    placeholder='Enter User Name'
                                    value={props.securityPage.selectedValue ? props.securityPage.selectedValue.userName : ""}
                                    onChange={(e) => { props.handleUserNameChange(e, { name: 'userName', value: e.target.value }) }}
                                />
                            </Form.Field>
                            {props.securityPage.selectedValue && props.securityPage.selectedValue.securitygroupID !== 4 &&
                                <Form.Field>
                                    <label>Group Access:<span style={{ color: '#f21b1b' }}>*</span></label>
                                    <Form.Select
                                        fluid
                                        name="groupAccess"
                                        value={props.securityPage.selectedValue ? props.securityPage.selectedValue.securitygroupID : ""}
                                        //options={props.securityPage.groupType}
                                        options={props.securityPage.userData.securityGroup}
                                        placeholder='Select group access'
                                        onChange={props.handleFormChange} />
                                </Form.Field>
                            }
                            {props.securityPage.selectedValue && props.securityPage.selectedValue.securitygroupID === 4 &&
                                <Form.Field>
                                    <label>Group Access:<span style={{ color: '#f21b1b' }}>*</span></label>
                                    <Form.Select
                                        fluid
                                        name="groupAccess"
                                        value={props.securityPage.selectedValue ? props.securityPage.selectedValue.securitygroupID : ""}
                                        disabled={props.securityPage.selectedValue && props.securityPage.selectedValue.securitygroupID === 4}
                                        options={props.securityPage.userData.withSuperAdminSecurityGroup}
                                        placeholder='Select group access'
                                    />
                                </Form.Field>
                            }
                        </Form.Group>
                        <Form.Group inline widths='equal'>
                            {props.securityPage.selectedValue && props.securityPage.selectedValue.securitygroupID === 4 &&
                                <Form.Field>
                                    <label>Password:</label>
                                    <Input>
                                        <Input
                                            placeholder='Enter Password'
                                            type={props.securityPage.isshowPasswordClick ? "text" : "password"}
                                            disabled={props.securityPage.selectedValue && props.securityPage.selectedValue.securitygroupID !== 4}
                                            //minLength="8"
                                            //maxLength="15"
                                            value={props.securityPage.selectedValue ? props.securityPage.selectedValue.password : ""}
                                            onChange={(e) => { utility.allowAllValuesExceptSpace(e); props.handlePasswordChange(e, { name: 'password', value: e.target.value }) }} /><Icon onClick={() => { props.handleHideShowPassword() }} name='eye' />
                                    </Input>
                                </Form.Field>
                            }
                            {props.securityPage.selectedValue && props.securityPage.selectedValue.securitygroupID === 4 &&
                                <Form.Field>
                                    <label>Confirm Password:</label>
                                    <Input>
                                        <Input
                                            placeholder='Confirm Password'
                                            type={props.securityPage.isshowConfirmPassword ? "text" : "password"}
                                            disabled={props.securityPage.selectedValue && props.securityPage.selectedValue.securitygroupID !== 4}
                                            //minLength="8"
                                            //maxLength="15"
                                            value={props.securityPage.selectedValue ? props.securityPage.selectedValue.confirmPassword : ""}
                                            onChange={(e) => { utility.allowAllValuesExceptSpace(e); props.handleConfirmPasswordChange(e, { name: 'confirmPassword', value: e.target.value }) }} /><Icon onClick={() => { props.handleHideShowConfirmPassword() }} name='eye' />
                                    </Input>
                                </Form.Field>}
                        </Form.Group>
                        <Form.Group inline widths='equal'>
                            <Form.Field>
                                <label>Project Level Access:<span style={{ color: '#f21b1b' }}>*</span></label>
                                <Dropdown
                                    options={props.securityPage.userData.division}
                                    placeholder='Select project level access'
                                    search
                                    selection
                                    fluid
                                    multiple
                                    name="projectLevelAccess"
                                    value={props.securityPage.selectedValue ? props.securityPage.selectedValue.divisionName : ""}
                                    onAddItem={props.handleAddition}
                                    onChange={props.handleDivisionChange}
                                />
                            </Form.Field>
                            <Form.Field>
                                <label style={{ opacity: props.securityPage.selectedValue.securitygroupID === 5 ? 0.45 : 1 }}>Device Access By Groups:{props.securityPage.selectedValue.securitygroupID === 5 ? '' : <span style={{ color: '#f21b1b' }}>*</span>}</label>
                                <Dropdown
                                    options={props.securityPage.userData.group}
                                    placeholder='Select device access by groups'
                                    search
                                    selection
                                    fluid
                                    multiple
                                    name="deviceAccessByGroups"
                                    value={props.securityPage.selectedValue ? props.securityPage.selectedValue.groupName : ""}
                                    onAddItem={props.handleAdditionGroup}
                                    onChange={props.handleGroupDivisionChange}
                                    disabled={props.securityPage.selectedValue.securitygroupID === 5}
                                />
                            </Form.Field>
                        </Form.Group>
                    </Form>
                </Modal.Content>
                <Modal.Actions>
                    {props.securityPage.isEditUser ?
                        <Button primary color='blue' type="submit" disabled={props.securityPage.isDisableSaveBtn} onClick={() => props.onSaveUser(props.securityPage.selectedValue.userId)}> Update </Button>
                        :
                        <Button primary color='blue' type="submit" disabled={props.securityPage.isDisableSaveBtn} onClick={() => props.onSaveUser()}> Save </Button>
                    }
                    <Button secondary color='red' onClick={() => props.onCloseModel()}> Cancel </Button>
                </Modal.Actions>
            </Modal>
            {props.securityPage.userDataList && props.securityPage.userDataList.length > 0 &&
                <Pagination floated="right"
                    activePage={props.securityPage.pagination.activePage}
                    onPageChange={props.onPageChange}
                    ellipsisItem={null}
                    firstItem={null}
                    lastItem={null}
                    totalPages={props.securityPage.pagination.totalCount} />
            }
        </div>
    );
}

export default SecurityPageComponent;

SecurityPageComponent.displayName = "SecurityPageComponent";